import script from "./Siding06Wraps.vue?vue&type=script&setup=true&lang=js"
export * from "./Siding06Wraps.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__